var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivePhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 6.24988H37.5",
    stroke: "#007FA1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 9.99988H37.5",
    stroke: "#007FA1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 13.7499H37.5",
    stroke: "#007FA1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 17.4999H37.5",
    stroke: "#007FA1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4494 19.5025C15.746 22.1534 17.8948 24.2924 20.5515 25.5769C20.7459 25.669 20.9609 25.7089 21.1754 25.6927C21.3899 25.6765 21.5964 25.6047 21.7747 25.4844L25.6866 22.8759C25.8596 22.7605 26.0586 22.6901 26.2657 22.6711C26.4728 22.6521 26.6813 22.685 26.8724 22.7669L34.1907 25.9033C34.4393 26.0089 34.6469 26.1925 34.7821 26.4263C34.9173 26.6601 34.9729 26.9315 34.9405 27.1997C34.7092 29.0097 33.826 30.6733 32.4564 31.8791C31.0869 33.0849 29.3247 33.7501 27.5 33.7502C21.8641 33.7502 16.4591 31.5113 12.474 27.5262C8.48883 23.541 6.25 18.136 6.25 12.5002C6.2501 10.6754 6.9153 8.9133 8.12106 7.54371C9.32683 6.17412 10.9905 5.291 12.8005 5.05968C13.0686 5.02723 13.34 5.08281 13.5739 5.21803C13.8077 5.35326 13.9912 5.5608 14.0968 5.80941L17.236 13.1341C17.3172 13.3235 17.3502 13.5301 17.3323 13.7355C17.3143 13.9408 17.2458 14.1385 17.1329 14.311L14.5335 18.2828C14.4152 18.4615 14.3453 18.6678 14.3305 18.8816C14.3158 19.0954 14.3567 19.3093 14.4494 19.5025V19.5025Z",
    stroke: "#007FA1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivePhone);
export default __webpack_public_path__ + "static/media/active-phone.15f81a6cb49529c74f7bb7f6342eb53c.svg";
export { ForwardRef as ReactComponent };